export default [
    {name: 'White', hexcode: 0xffffff},
    {name: 'Grey', hexcode: 0xa3a3a3},
    {name: 'Charcoal', hexcode: 0x212121},
    {name: 'Red', hexcode: 0xe62929},
    {name: 'Orange', hexcode: 0xe65229},
    {name: 'Gold', hexcode: 0xe67e29},
    {name: 'Olive', hexcode: 0xe6bd29},
    {name: 'Lemon', hexcode: 0xdce629},
    {name: 'Lime', hexcode: 0x94e629},
    {name: 'Green', hexcode: 0x29e636},
    {name: 'Aqua', hexcode: 0x29e6a7},
    {name: 'Cyan', hexcode: 0x29e6e6},
    {name: 'Blue', hexcode: 0x29bae6},
    {name: 'Sapphire', hexcode: 0x2978e6},
    {name: 'Deep Blue', hexcode: 0x3f29e6},
    {name: 'Purple', hexcode: 0xa029e6},
    {name: 'Magenta', hexcode: 0xe629d0},
    {name: 'Rose', hexcode: 0xe62968},
    {name: 'Pink', hexcode: 0xf07fa5},
    {name: 'Apricot', hexcode: 0xf07f7f},
    {name: 'Sand', hexcode: 0xf0ac7f},
    {name: 'Yellow', hexcode: 0xf0ee7f},
    {name: 'Kiwi', hexcode: 0xa8f07f},
    {name: 'Ocean', hexcode: 0x7ff0b5},
    {name: 'Sky Blue', hexcode: 0x7fe4f0},
    {name: 'Cornflower', hexcode: 0x7f9ff0},
    {name: 'Pastel Purple', hexcode: 0xb77ff0},
    {name: 'Pastel Pink', hexcode: 0xf07fce},
    {name: 'Maroon', hexcode: 0x801717},
    {name: 'Brown', hexcode: 0x804b17},
    {name: 'Forest Green', hexcode: 0x3a8017},
    {name: 'Cerulean', hexcode: 0x176480},
];